const SolarIcon = ({ fillColor, strokeColor, strokeWidth, circleStrokeWidth, width }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24" width={width}>
      <circle
        cx="11.94"
        cy="11.94"
        r="4.26"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth={circleStrokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="11.94"
        y1="1"
        x2="11.94"
        y2="3.92"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="11.94"
        y1="19.97"
        x2="11.94"
        y2="22.89"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="22.89"
        y1="11.94"
        x2="19.97"
        y2="11.94"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="3.92"
        y1="11.94"
        x2="1"
        y2="11.94"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="19.68"
        y1="4.21"
        x2="17.62"
        y2="6.27"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="6.27"
        y1="17.62"
        x2="4.21"
        y2="19.68"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="19.68"
        y1="19.68"
        x2="17.62"
        y2="17.62"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="6.27"
        y1="6.27"
        x2="4.21"
        y2="4.21"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SolarIcon;
